module.exports = __webpack_public_path__ + "static/img/logo_hnzwy.7831098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_hnzwy.png
// module id = 903s
// module chunks = 15